import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface BenefitValues {
  appliesFrom: string
  value: string
}
export interface Benefits {
  code: string
  name: string
  to: string
  from: string
  payrolls: any[]
  sucursals: any[]
  departments: any[]
  positions: any[]
  values: BenefitValues[]
}
export interface BenefitsDelete {
  causeOfElimination: string
}

export async function getBenefits(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['benefits.is_deleted = false', 'benefits.company_id = :companyId']
  if (search) {
    where.push(
      `CONCAT(benefits.name, benefits.code, benefits.to, benefits.from, department.code, department.name, position.code, position.name, payroll.code, payroll.name, sucursal.code, sucursal.name, (SELECT value FROM benefit_values bv WHERE bv.benefit_id = benefits.id AND is_deleted = false ORDER BY bv.updated_at DESC LIMIT 1)) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = [
    'GROUP BY benefits.id, payroll.code, payroll.name, sucursal.code, sucursal.name, department.code, department.name, position.code, position.name'
  ]
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? modifier.push(
          `ORDER BY (CASE WHEN benefits.code ~ '^[0-9]+$' THEN CAST(benefits.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, benefits.code ${dataOrder[0]}`
        )
      : modifier.push(`ORDER BY ${dataOrder[1]} ${dataOrder[0]}`)
    : modifier.push(
        "ORDER BY (CASE WHEN benefits.code ~ '^[0-9]+$' THEN CAST(benefits.code AS NUMERIC) ELSE NULL END), benefits.code"
      )
  // result
  const response: any = await getData({
    tables: ['pg_benefits'],
    fields: [
      'benefits.id',
      'benefits.code',
      'benefits.name',
      'benefits.from',
      'benefits.to',
      "CONCAT(payroll.code, ' - ', payroll.name) AS payroll",
      'jsonb_array_length(benefits.payrolls) -1 AS payrolls_number',
      "CONCAT(sucursal.code, ' - ', sucursal.name) AS sucursal",
      'jsonb_array_length(benefits.sucursals) -1 AS sucursals_number',
      "CONCAT(department.code, ' - ', department.name) AS department",
      'jsonb_array_length(benefits.departments) -1 AS departments_number',
      "CONCAT(position.code, ' - ', position.name) AS position",
      'jsonb_array_length(benefits.positions) -1 AS positions_number',
      '(SELECT value FROM benefit_values bv WHERE bv.benefit_id = benefits.id AND is_deleted = false ORDER BY bv.updated_at DESC LIMIT 1) as value',
      'benefits.updated_at'
    ],
    join: [
      'LEFT JOIN LATERAL (SELECT code, name FROM payrolls WHERE id = (SELECT jsonb_array_elements_text(benefits.payrolls) LIMIT 1)::uuid) AS payroll ON true',
      'LEFT JOIN LATERAL (SELECT code, name FROM sucursals WHERE id = (SELECT jsonb_array_elements_text(benefits.sucursals) LIMIT 1)::uuid) AS sucursal ON true',
      'LEFT JOIN LATERAL (SELECT code, name FROM departments WHERE id = (SELECT jsonb_array_elements_text(benefits.departments) LIMIT 1)::uuid) AS department ON true',
      'LEFT JOIN LATERAL (SELECT code, name FROM positions WHERE id = (SELECT jsonb_array_elements_text(benefits.positions) LIMIT 1)::uuid) AS position ON true'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getBenefit(id: string): Promise<Benefits> {
  const data = await getData<any>({
    tables: ['pg_benefits'],
    fields: [
      'id',
      'code',
      'name',
      'benefits.to',
      'benefits.from',
      'departments',
      'payrolls',
      'positions',
      'sucursals',
      'updated_at'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createBenefit(data: Benefits): Promise<boolean> {
  const response: any = await http.post('/calculation/benefits', {
    code: data.code,
    name: data.name,
    to: data.to,
    from: data.from,
    payrolls: data.payrolls,
    sucursals: data.sucursals,
    departments: data.departments,
    positions: data.positions,
    values: data.values
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateBenefit(
  data: Benefits,
  id: string
): Promise<boolean> {
  const response: any = await http.put('/calculation/benefits/' + id, {
    code: data.code,
    name: data.name,
    to: data.to,
    from: data.from,
    payrolls: data.payrolls,
    sucursals: data.sucursals,
    departments: data.departments,
    positions: data.positions,
    values: data.values
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteBenefit(
  data: BenefitsDelete,
  id: string
): Promise<boolean> {
  const response: any = await http.put('/calculation/benefits/delete/' + id, {
    causeOfElimination: data.causeOfElimination
  })
  if (response?.data?.data?.error) {
    return false
  }
  return true
}
